import { FileUpload } from "../../components";

export const View = (props) => {
  const { register, onChange, ...rest } = props;

  return (
    <FileUpload
      {...register(props.name)}
      {...rest}
      onChange={onChange}
      containerClassName={`input-container file-upload--input ${props.containerClassName}`}
    />
  );
};
